import m from "../../fonts/es2015/notosans-sc";
window.am4fonts_notosans_sc = m;


//////////////////
// WEBPACK FOOTER
// ./fonts/notosans-sc.js
// module id = null
// module chunks = 